// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__2tlAJ","wh1":"Label_wh1__1Xb_v"};